/** @format */

import angular from 'angular';
import angularTranslate from 'angular-translate';
import { I18nModule } from 'crowdcomms-js/lib/i18n';

import { EditToolsI18nConfig } from './edit-tools-i18n.config.js';

export const EditToolsI18nModule = angular
    .module('galabid-presenter.components.edit-tools.i18n', [angularTranslate, I18nModule])
    .config(EditToolsI18nConfig).name;
